import { defineMessages } from 'react-intl'

const scope = `procurify.platform.legal-entities.features.list-requestable-legal-entities.presenters.use-requestable-legal-entities-presenter`

export default defineMessages({
  errorToastTitle: {
    id: `${scope}.errorToastTitle`,
    defaultMessage: 'Error',
  },
  loadErrorToastMessage: {
    id: `${scope}.loadErrorToastMessage`,
    defaultMessage: 'Failed to load entities',
  },
})
